export const SERVICE_GET_ALL = 'SERVICE_GET_ALL'
export const SERVICE_GET_ALL_SUCCESS = 'SERVICE_GET_ALL_SUCCESS'
export const SERVICE_GET_ALL_ERROR = 'SERVICE_GET_ALL_ERROR'
export const SERVICE_CHANGE_BG_COLOR = 'SERVICE_CHANGE_BG_COLOR'
export const SERVICE_GET_ALL_BY_SITE_ID = 'SERVICE_GET_ALL_BY_SITE_ID'
export const SERVICE_GET_ALL_BY_SITE_ID_SUCCESS =
  'SERVICE_GET_ALL_BY_SITE_ID_SUCCESS'
export const SERVICE_GET_ALL_BY_SITE_ID_ERROR =
  'SERVICE_GET_ALL_BY_SITE_ID_ERROR'
